export const PHOTOS = {
  hero: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/wv5iupjl_121A8024.JPG",
  about: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/9f62o2kx_Snapchat-691089592.jpg",
  redDress: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/1u87o0vn_121A0025.JPG",
  hikeDuo: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/fkwk3vod_20240627231700_121A1543.JPG",
  hoodieForest: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/5os7jl3y_20240627225034_121A1373.JPG",
  athletePortrait: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/3flf8bvj_121A5808%281%29.jpg",
  athleteDuo: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/ev677bln_121A5837.JPG",
  athleteLaugh: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/78taxj29_121A5829.JPG",
  urbanGraffiti: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/k2lvhsb3_121A5046.JPG",
  groupEvent: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/vq2mqybd_121A8075.jpg",
  familyCarnival: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/j3fe0ttl_20250127_110150.jpg",
  redVelvetGarden: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/irifrfao_121A0025.JPG",
  seniorGrass: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/omarz0g8_121A6420.JPG",
  headshotPorch: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/rd0l1bmm_121A6305.JPG",
  storySenior: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/jb9vo570_121A2180.JPG",
  storyCheer: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/rkignxx5_20260503_231854%281%29.jpg",
  storyDenver: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/8ybt3ygl_121A1549.JPG",
  galleryRose: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/x8emfj3q_c1.jpg",
  galleryHocoBoy: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/twcih7an_121A8227.JPG",
  galleryRoseBrick: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/34fijcyt_121A7769.JPG",
  galleryPearlDress: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/d1o97dli_121A2214.JPG",
  galleryFriendsBouquet: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/e3ir7sz9_121A2177.JPG",
  galleryPinkAlley: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/ao7745qc_121A1061.jpg",
  galleryTreeLog: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/bdbzmef1_IMG_4451.JPG",
  headshotPorchSitting: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/f7zxdzl8_121A6300.JPG",
  eventOrangePromGate: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/frpoj0fi_20250517_220243.jpg",
  eventPearlWhiteFall: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/ukl0at2m_121A2214.JPG",
  eventDuoBouquets: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/l0pyqrxw_121A2177.JPG",
  eventBlackSequinRose: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/pcrfyz2x_121A7784.jpg",
  eventOrangeShirtBrick: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/fd1ct2wr_Meko.jpg",
  eventTuxIvoryTieLambo: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/yjicz081_file_00000000d8e4720cac8437509d6015af.png",
  eventBlackSuitShadesLambo: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/k7gogz4v_file_000000007dc871f88e846ebbb7463646.png",
  eventGirlSmileLamboHood: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/x3h4dkmg_file_00000000278071fd93fe5a76090b4d1e.png",
  eventGirlSequinLambo: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/6co6sih0_file_0000000026d071fd8a15790c171716ea.png",
  eventGreenTuxLambo: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/ezhapliw_file_00000000a10871f5a01c284ec9cf708f%20%281%29.png",
  seniorTuxPairTree: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/rj5rszty_IMG_4781%281%29.jpg",
  seniorCoupleColumns: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/sft1of1l_121A9124.jpg",
  seniorTrioColumns: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/3qnge2i0_121A8975.jpg",
  seniorEmeraldTuxSolo: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/hjmhh0hu_file_000000003fa0720caf1aeaf8781eb1a0.png",
  seniorNavyEmeraldCouple: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/h153ykwj_file_000000000e4c722fba3439e8c7529805.png",
  familyMomKissSon: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/92pgkc5o_121A0069.JPG",
  familyCouple: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/4miztstv_IMG_4969.JPG",
  familyDadFourGirls: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/hv2k4m7f_IMG_4977.jpg",
  familyBigGroup: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/ikiwous7_IMG_5006.jpg",
  familyEightWithChild: "https://customer-assets.emergentagent.com/job_portfolio-builder-940/artifacts/aw8h2qgf_121A9893.JPG",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Stories", href: "#stories" },
  { label: "Book", href: "#book" },
  { label: "Contact", href: "#contact" },
];

export const PROMO = {
  enabled: true,
  // Bump this version string whenever the promo copy changes so dismissed users see it again.
  version: "summer-2026-v1",
  eyebrow: "Limited time",
  message: "$25 off Senior & Family sessions booked before June 15",
  cta: { label: "Book now", href: "#book" },
};

export const SERVICES = [
  {
    id: "family",
    title: "Family / Group Vision",
    tagline: "A complete update of your family photos",
    price: "$300",
    duration: "60 minutes",
    badge: "Most Booked",
    description:
      "A 60-minute session — the best option for a full family or group update with room to play with combinations: parents, kids, sibling groupings, the whole crew. Built for up to 8 individuals.",
    image: PHOTOS.groupEvent,
    bullets: [
      "60-minute session",
      "Up to 8 individuals",
      "All family + group combinations",
      "10 high-res digital images included",
      "Online gallery + social collage",
      "Add-ons for additional or \"All\" photos",
      "Planning + talent included",
    ],
  },
  {
    id: "urban",
    title: "Urban Visions",
    tagline: "Downtown grit · cinematic light · your story",
    price: "$200",
    duration: "60 – 75 minutes",
    badge: "Most Booked",
    description:
      "A 60–75 minute session in downtown / urban scenery — brick alleys, neon, golden hour skyline. Two outfit changes built in. Perfect for portraits, content drops, or just because.",
    image: PHOTOS.urbanGraffiti,
    bullets: [
      "60–75 minute session",
      "Downtown / urban scenery",
      "2 outfit changes",
      "Online gallery + social collage",
      "Add-ons for additional or \"All\" photos",
      "Basic image editing + planning",
    ],
  },
  {
    id: "senior",
    title: "Senior Vision",
    tagline: "Yearbook-ready · senior year, captured",
    price: "$300",
    duration: "90 minutes",
    description:
      "A 90-minute senior session with up to 3 outfit changes — the full senior-year experience, with a retouched yearbook image and a curated set of digital photos to keep forever.",
    image: PHOTOS.seniorGrass,
    bullets: [
      "90-minute session",
      "Up to 3 outfit changes",
      "Retouched yearbook photo",
      "10 high-res digital images",
      "Add-on prints available",
    ],
  },
  {
    id: "mini",
    title: "Mini Vision",
    tagline: "Quick update · perfect for holiday cards",
    price: "$150",
    duration: "30 minutes",
    description:
      "A 30-minute session — the best option for a quick update of family photos. Poses and family combinations are limited, but it's ideal for holiday cards and seasonal refreshes.",
    image: PHOTOS.hikeDuo,
    bullets: [
      "30-minute session",
      "5 high-res digital photos",
      "Online gallery",
      "Basic image editing",
      "Planning + talent included",
    ],
  },
  {
    id: "headshot",
    title: "Headshot Vision",
    tagline: "Casual or corporate · ready for LinkedIn",
    price: "$150",
    duration: "30 minutes",
    description:
      "A 30-minute headshot session — great for updating professional photos for personal use, branding, or your team page. Casual or corporate, your call.",
    image: PHOTOS.headshotPorchSitting,
    imagePosition: "center 8%",
    bullets: [
      "30-minute session",
      "Casual or corporate",
      "3 high-res digital photos",
      "Basic image editing",
      "Planning + talent included",
    ],
  },
  {
    id: "athlete",
    title: "Athlete Vision",
    tagline: "Cheer · dance · sport · the grind, captured",
    price: "$150",
    duration: "30 minutes",
    teamRate: "Book 5+ athletes from the same team · save $25 each",
    description:
      "A 30-minute session for athletes — cheer, dance, gymnastics, track, the grind. Bring your uniform, your bow, your jersey. Built for senior nights, signing day, and end-of-season galleries that hit harder than the trophy.",
    image: PHOTOS.athletePortrait,
    bullets: [
      "30-minute session",
      "Uniform / kit / sport-specific",
      "Action + portrait shots",
      "5 high-res digital photos",
      "Online gallery",
      "Team rate available · save $25 each",
    ],
  },
  {
    id: "extended",
    title: "Vision of My Family",
    tagline: "Big families · grandparents · cousins · everyone",
    price: "$450",
    duration: "Up to 90 minutes",
    description:
      "Built for families larger than 8 individuals — multiple sub-families, three generations, the whole tree in one frame. Poses include grandparents, grandparents with grandkids, adult siblings, cousins, and individual sub-family portraits — nobody gets left out. Add additional sub-families for $25 each.",
    image: PHOTOS.familyCarnival,
    bullets: [
      "Up to 90 minutes",
      "For families larger than 8 individuals",
      "Sub-family + generation poses",
      "15 high-res digital images included",
      "+$25 per additional sub-family",
      "Online gallery + social collage",
      "Add-ons for additional or \"All\" photos",
    ],
  },
];

export const EVENT_PACKAGES = {
  title: "Special Event Vision",
  examples: "Prom · Homecoming · birthdays · gatherings",
  base: "Starts at $200 for 2 hours of coverage",
  hourly: "Each additional hour · $100",
  note: "Detailed package pricing available by email — every event is a little different.",
  image: PHOTOS.redVelvetGarden,
};

export const SERVICES_DISCLAIMER =
  "All prices are subject to change without notice. Session fees are non-refundable. Add-ons available — prints à la carte and the “All of Them” digital package upgrade.";

export const GALLERY = [
  { src: PHOTOS.urbanGraffiti, alt: "Urban portrait against graffiti sunburst", category: "Urban", aspect: "tall" },
  { src: PHOTOS.galleryRose, alt: "Senior in black sequin dress with rose downtown", category: "Events", aspect: "tall", position: "center 18%" },
  { src: PHOTOS.athleteDuo, alt: "Cheer duo on a Colorado balcony", category: "Athletes", aspect: "wide" },
  { src: PHOTOS.galleryRoseBrick, alt: "Senior in sequin dress with rose against brick", category: "Events", aspect: "tall", position: "center 18%" },
  { src: PHOTOS.galleryHocoBoy, alt: "HOCO portrait in orange shirt on the steps", category: "Urban", aspect: "tall" },
  { src: PHOTOS.galleryFriendsBouquet, alt: "Friends with HOCO bouquets on a bench", category: "Seniors", aspect: "wide" },
  { src: PHOTOS.hero, alt: "Editorial street portrait", category: "Urban", aspect: "tall" },
  { src: PHOTOS.galleryPinkAlley, alt: "Pink top in a graffiti alley", category: "Urban", aspect: "tall" },
  { src: PHOTOS.redDress, alt: "Red gown in tropical garden", category: "Portraits", aspect: "tall" },
  { src: PHOTOS.galleryPearlDress, alt: "Senior in pearl dress under fall leaves", category: "Seniors", aspect: "tall" },
  { src: PHOTOS.athleteLaugh, alt: "Cheer teammates laughing", category: "Athletes", aspect: "wide" },
  { src: PHOTOS.galleryTreeLog, alt: "Senior on a fallen tree, golden hour", category: "Seniors", aspect: "tall" },
  { src: PHOTOS.hikeDuo, alt: "Friends hiking in Colorado pines", category: "Portraits", aspect: "wide" },
  { src: PHOTOS.hoodieForest, alt: "Portrait in white hoodie by the creek", category: "Portraits", aspect: "tall" },
  { src: PHOTOS.athletePortrait, alt: "Solo cheer portrait, mountain backdrop", category: "Athletes", aspect: "tall" },
  { src: PHOTOS.about, alt: "Downtown style portrait at golden hour", category: "Portraits", aspect: "wide" },
  { src: PHOTOS.eventOrangePromGate, alt: "Prom portrait in orange sequin gown by the gate", category: "Events", aspect: "tall", position: "center 15%" },
  { src: PHOTOS.eventPearlWhiteFall, alt: "HOCO portrait in pearl dress under fall leaves", category: "Events", aspect: "tall", position: "center 18%" },
  { src: PHOTOS.eventDuoBouquets, alt: "HOCO friends with bouquets on a memorial bench", category: "Events", aspect: "wide", position: "center 22%" },
  { src: PHOTOS.eventBlackSequinRose, alt: "HOCO portrait in black sequins with single rose", category: "Events", aspect: "tall", position: "center 18%" },
  { src: PHOTOS.eventOrangeShirtBrick, alt: "HOCO portrait in orange shirt downtown", category: "Events", aspect: "tall", position: "center 18%" },
  { src: PHOTOS.eventTuxIvoryTieLambo, alt: "Prom arrival · black tuxedo with ivory tie · yellow Lamborghini", category: "Events", aspect: "tall", position: "70% 25%" },
  { src: PHOTOS.eventBlackSuitShadesLambo, alt: "Prom arrival · all-black suit + shades stepping out of yellow Lamborghini", category: "Events", aspect: "tall", position: "55% 15%" },
  { src: PHOTOS.eventGirlSmileLamboHood, alt: "Prom arrival · smiling over yellow Lamborghini hood with bouquet", category: "Events", aspect: "wide", position: "55% 30%" },
  { src: PHOTOS.eventGirlSequinLambo, alt: "Prom portrait · sequin gown against yellow Lamborghini", category: "Events", aspect: "tall", position: "60% 30%" },
  { src: PHOTOS.eventGreenTuxLambo, alt: "Prom arrival · emerald-trim tuxedo stepping out of yellow Lamborghini", category: "Events", aspect: "tall", position: "65% 22%" },
  { src: PHOTOS.seniorTuxPairTree, alt: "Senior prom · best friends in emerald & black tuxedos under the tree", category: "Seniors", aspect: "tall", position: "center 22%" },
  { src: PHOTOS.seniorCoupleColumns, alt: "Senior prom couple · champagne sequins & black tux at the columns", category: "Seniors", aspect: "tall", position: "center 28%" },
  { src: PHOTOS.seniorTrioColumns, alt: "Senior prom trio · navy, gold, and navy gowns at the columns", category: "Seniors", aspect: "wide", position: "center 30%" },
  { src: PHOTOS.seniorEmeraldTuxSolo, alt: "Senior solo · emerald-trim tuxedo under the oak tree", category: "Seniors", aspect: "tall", position: "center 22%" },
  { src: PHOTOS.seniorNavyEmeraldCouple, alt: "Senior prom couple · navy sequin gown & emerald tux under the tree", category: "Seniors", aspect: "tall", position: "center 20%" },
  { src: PHOTOS.familyMomKissSon, alt: "Family of three in cream linens · mom kisses her son in the sun", category: "Families", aspect: "tall", position: "center 28%" },
  { src: PHOTOS.familyCouple, alt: "Couple in white at the rock garden", category: "Families", aspect: "tall", position: "center 22%" },
  { src: PHOTOS.familyDadFourGirls, alt: "Dad with his four daughters in cream by the canyon", category: "Families", aspect: "wide", position: "center 35%" },
  { src: PHOTOS.familyBigGroup, alt: "Extended family of twelve in cream — three generations together", category: "Families", aspect: "wide", position: "center 38%" },
  { src: PHOTOS.familyEightWithChild, alt: "Family of eight in cream at the canyon path", category: "Families", aspect: "wide", position: "center 30%" },
];

export const GALLERY_FILTERS = ["All", "Urban", "Athletes", "Portraits", "Families", "High School", "Seniors", "Events"];

export const SESSION_TYPES = [
  "Family / Group Vision (60 min · $300 · up to 8 people)",
  "Urban Visions (60–75 min · $200)",
  "Senior Vision (90 min · $300)",
  "Athlete Vision (30 min · $150)",
  "Mini Vision (30 min · $150)",
  "Headshot Vision (30 min · $150)",
  "Vision of My Family (up to 90 min · $450 · 8+ people)",
  "Special Event Vision (Prom · HOCO · custom)",
  "Not sure yet — let's chat",
];

export const TESTIMONIALS = [
  {
    quote: "Jas made our whole family feel comfortable from the first hello — even our toughest critic (my 7-year-old) was cracking up by minute two. The photos feel like us. We didn't pose, we just lived, and she caught all of it.",
    name: "The Coleman Family",
    role: "Family Session · Cherry Creek",
  },
  {
    quote: "I was so nervous about my senior shoot, but Jas just gets it. She made me laugh, gave me real direction, and somehow every single photo looks like the best version of me. I can't pick a favorite — I want them all on my wall.",
    name: "Aaliyah J.",
    role: "Senior Portraits · Aurora",
  },
  {
    quote: "Booking with ManeVzion was the easiest decision I've made. Jas is warm, fast to respond, and her gallery turnaround is unreal. She turned a regular afternoon into our family's favorite memory. I'm already booking next year.",
    name: "Marcus & Tia",
    role: "Lifestyle Session · RiNo",
  },
];

export const STORIES = [
  {
    title: "Why Denver has my whole heart",
    excerpt: "30+ years calling Colorado home and I still find a new corner of this city worth shooting every week. Here's where I keep going back, and why.",
    date: "Jan 2026",
    tag: "Field Notes",
    image: PHOTOS.storyDenver,
  },
  {
    title: "Why color belongs in your senior shoot",
    excerpt: "A short essay on why I push clients toward bold colors — red gowns, green shorts — and how it changes the whole feel of a gallery.",
    date: "Dec 2025",
    tag: "Process",
    image: PHOTOS.storySenior,
  },
  {
    title: "Cheer-mom on the road — capturing the in-betweens",
    excerpt: "17 years of cheer comps have taken our family across this country. The best photos almost never happen on the mat — here's where they actually live.",
    date: "Nov 2025",
    tag: "Stories",
    image: PHOTOS.storyCheer,
  },
];
